// extracted by mini-css-extract-plugin
export var dropdownButton = "_3d-0";
export var fullWidthDropdownButton = "_3d-1";
export var icon = "_3d-3";
export var iconPlaceholder = "_3d-2";
export var shortcutContainer = "_3d-4";